import Actions from './winner-actions';
import Model from './winner-model';
import reducer from './winner-reducer';
import Selectors from './winner-selectors';
import sagas from './winner-sagas';
import Api from './winner-api';

export default {
  Actions,
  Api,
  Model,
  namespace: 'winner',
  reducer,
  sagas:     [sagas],
  Selectors,
};
